export default {
  YEAR_IN_SECONDS: 31536000,
  HALF_AN_HOUR_IN_SECONDS: 1800,
  SECOND_IN_MILLISECONDS: 1000,
  HUNDRED_MILLISECONDS: 100
};
